import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const EMITTING_COLOR = "rgb(250,125,50)";
const REMOVING_COLOR = "rgb(52,168,83)";

// Diverging horizontal bar chart from a zero baseline. Values are signed (soil
// carbon change is typically negative = sequestration), so this is intentionally
// NOT a pie/donut -- a pie can't represent a negative slice.
export default function GHGEmissionsBreakdownChart({ emissions }) {
  if (!emissions) return null;

  const data = [
    { name: "Carbon Dioxide (CO2)", value: emissions.carbonDioxideKgCo2e ?? 0 },
    { name: "Nitrous Oxide (N2O)", value: emissions.nitrousOxideKgCo2e ?? 0 },
    { name: "Methane (CH4)", value: emissions.methaneKgCo2e ?? 0 },
    { name: "Soil Carbon Change", value: emissions.soilCarbonChangeKgCo2e ?? 0 },
  ];

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 40, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" tickFormatter={(v) => `${v.toLocaleString()}`} />
        <YAxis type="category" dataKey="name" width={160} />
        <ReferenceLine x={0} stroke="#666" />
        <Tooltip
          formatter={(value) => [`${Number(value).toLocaleString()} kg CO2e`, "Amount"]}
        />
        <Bar dataKey="value" isAnimationActive={false}>
          <LabelList
            dataKey="value"
            position="right"
            formatter={(v) => `${Number(v).toLocaleString()} kg CO2e`}
          />
          {data.map((entry) => (
            <Cell
              key={entry.name}
              fill={entry.value < 0 ? REMOVING_COLOR : EMITTING_COLOR}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
